export enum ThemeGameImageState {
  image1 = 'image1',
  image2 = 'image2',
  image3 = 'image3',
  image4 = 'image4',
  theme = 'theme'
}
